/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableVariable.ts
 * Project: mle-client-n
 * Committed last: 2022/1/17 @ 844
 * ---
 * Description:
 */

import {
  defaultSetterOptions,
  ObservableSetterOptions,
  ObservableShape
}                                                       from './ObservableShape';
import Pamela
                                                        from '@revodigital/pamela';
import { action, computed, makeObservable, observable } from 'mobx';
import { Editor }                                       from './Editor';

export class ObservableVariable extends ObservableShape<Pamela.ExportVariable> {
  @observable
  private _varName: string;

  constructor(shape: Pamela.ExportVariable, editor: Editor) {
    super(shape, editor);
    this._varName = shape.variableName();
    makeObservable(this);
  }

  @action
  public setVariableName(value: string, options: ObservableSetterOptions = defaultSetterOptions) {
    this._varName = value;

    if (options.applyToPamelaShape) {
      this.pamelaShape__nonObservable.variableName(
        this._varName);
      this.pamelaShape__nonObservable.draw();
    }
  }

  @computed
  public get variableName() {
    return this._varName;
  }
}